import { StyleSheet } from 'aphrodite';

export const s = StyleSheet.create({
	dropdownTrigger: {
		minWidth: '200px',
	},
});
